import { z } from 'zod';
import { ServiceIdentityBaseSchema } from './base';
export const CurrentServiceIdentitySchema = ServiceIdentityBaseSchema.extend({
    eAccountKeyByServiceIdentitySecretKey: z.string(),
});
